import { render, staticRenderFns } from "./transferToLongTermStorageWarehouse.vue?vue&type=template&id=0f91b475&scoped=true&"
import script from "./transferToLongTermStorageWarehouse.vue?vue&type=script&lang=js&"
export * from "./transferToLongTermStorageWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./transferToLongTermStorageWarehouse.vue?vue&type=style&index=0&id=0f91b475&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f91b475",
  null
  
)

export default component.exports